import { deleteFeedbackById } from "@/api";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { DestructiveDialogProps } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog.types";
import { Delete } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";

interface IProps {
    /**
     * The id of the feedback to delete
     */
    feedbackId: number;
}

/**
 * Datagrid action item to delete a feedback
 */
export const DeleteFeedbackButton = ({ feedbackId }: IProps) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const dialogProps: DestructiveDialogProps = {
        itemId: feedbackId,
        subject: "feedback",
        mutationFn: deleteFeedbackById,
        onSucceeded: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-feedback"],
            });
        },
    };
    const handleDelete = async () => {
        await dialogs.open(DestructiveDialog, dialogProps);
    };

    return (
        <GridActionsCellItem
            icon={<Delete />}
            label="Delete Feedback"
            onClick={handleDelete}
        />
    );
};
